import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Box } from "../../Box/Box.mjs";
import { FieldMessage } from "../../FieldMessage/FieldMessage.mjs";
import { Text } from "../../Text/Text.mjs";
import { virtualTouchable } from "../touchable/virtualTouchable.mjs";
import { mergeIds } from "../mergeIds.mjs";
import { Inline } from "../../Inline/Inline.mjs";
import { StyledInput } from "./StyledInput.mjs";
import { root, labelOffset, badgeOffset, children } from "./InlineField.css.mjs";
const DefaultWrapperComponent = ({ children: children2 }) => /* @__PURE__ */ jsx(Box, { display: "flex", children: children2 });
const InlineField = forwardRef(
  ({
    id,
    name,
    value,
    checked,
    data,
    onChange,
    label,
    labelWeight,
    type,
    children: children$1,
    description,
    badge,
    message,
    reserveMessageSpace = false,
    tone = "neutral",
    disabled = false,
    required,
    tabIndex,
    size = "standard",
    "aria-describedby": ariaDescribedBy,
    icon,
    wrapper: WrapperComponent = DefaultWrapperComponent,
    fullField
  }, forwardedRef) => {
    const messageId = `${id}-message`;
    const descriptionId = `${id}-description`;
    const hasMessage = message || reserveMessageSpace;
    return /* @__PURE__ */ jsxs(Box, { position: "relative", zIndex: 0, className: root, children: [
      /* @__PURE__ */ jsxs(WrapperComponent, { children: [
        /* @__PURE__ */ jsx(
          StyledInput,
          {
            type,
            id,
            checked,
            name,
            value,
            data,
            onChange,
            disabled,
            tone,
            tabIndex,
            required,
            "aria-describedby": mergeIds(
              ariaDescribedBy,
              message ? messageId : void 0,
              description ? descriptionId : void 0
            ),
            size,
            ref: forwardedRef,
            fullField
          }
        ),
        /* @__PURE__ */ jsxs(Box, { paddingLeft: "small", flexGrow: 1, children: [
          /* @__PURE__ */ jsxs(Inline, { space: "small", children: [
            /* @__PURE__ */ jsx(
              Box,
              {
                component: "label",
                htmlFor: id,
                userSelect: "none",
                display: "block",
                cursor: !disabled ? "pointer" : void 0,
                className: [labelOffset[size], virtualTouchable()],
                children: /* @__PURE__ */ jsx(Text, { weight: labelWeight, tone: disabled ? "disabled" : void 0, size, children: label })
              }
            ),
            badge ? /* @__PURE__ */ jsx(Box, { className: badgeOffset[size], children: badge }) : null
          ] }),
          description ? /* @__PURE__ */ jsx(Box, { paddingTop: "small", children: /* @__PURE__ */ jsx(Text, { tone: "secondary", size, id: descriptionId, children: description }) }) : null,
          children$1 ? /* @__PURE__ */ jsx(Box, { paddingTop: "xxxsmall", className: children, children: children$1 }) : null
        ] }),
        icon ? /* @__PURE__ */ jsx(Box, { className: children, children: icon }) : null
      ] }),
      hasMessage ? /* @__PURE__ */ jsx(Box, { paddingTop: description ? "small" : "xsmall", children: /* @__PURE__ */ jsx(
        FieldMessage,
        {
          id: messageId,
          tone,
          disabled,
          message,
          reserveMessageSpace
        }
      ) }) : null
    ] });
  }
);
export {
  InlineField
};
